"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStackString = exports.isStackIStackFrame = exports.logLevelColorMap = exports.LogLevel = exports.LogPrependLetter = exports.LogSource = void 0;
var LogSource;
(function (LogSource) {
    LogSource["WEBSITE_BACKEND"] = "WB";
    LogSource["WEBSITE_FRONTEND"] = "WF";
    LogSource["CONTENT_BACKEND"] = "CB";
    LogSource["CONTENT_FRONTEND"] = "CF";
    LogSource["COMMON"] = "COMMON";
})(LogSource || (exports.LogSource = LogSource = {}));
var LogPrependLetter;
(function (LogPrependLetter) {
    LogPrependLetter["USER"] = "U";
    LogPrependLetter["EMAIL"] = "E";
    LogPrependLetter["COURSE"] = "C";
    LogPrependLetter["SESSION"] = "S";
    LogPrependLetter["REQUEST"] = "R";
    LogPrependLetter["FUNCTION_NAME"] = "FN";
    LogPrependLetter["FILEPATH"] = "FP";
})(LogPrependLetter || (exports.LogPrependLetter = LogPrependLetter = {}));
var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
exports.logLevelColorMap = new Map([
    [LogLevel.DEBUG, 'greenBright'],
    [LogLevel.INFO, 'blueBright'],
    [LogLevel.WARN, 'magentaBright'],
    [LogLevel.ERROR, 'redBright'],
]);
const isStackIStackFrame = (stack) => {
    return stack instanceof Array;
};
exports.isStackIStackFrame = isStackIStackFrame;
const isStackString = (stack) => {
    return stack instanceof String;
};
exports.isStackString = isStackString;
//# sourceMappingURL=BackendLogger.types.js.map